import type { MetricRange } from '@/schemas/commons';

export const RANGES: MetricRange[] = ['24h', '7d', '30d'];
export const DEFAULT_RANGE: MetricRange = '24h';

export const RANGE_LABEL_KEY: Record<MetricRange, string> = {
	'24h': 'RANGE_24H',
	'7d': 'RANGE_7D',
	'30d': 'RANGE_30D',
};

/** Unlisted layers fall back to their raw name. */
export const LAYER_LABEL_KEY: Partial<Record<string, string>> = {
	valentina: 'LAYER_VALENTINA',
	grounding_check: 'LAYER_GROUNDING_CHECK',
	rag: 'LAYER_RAG',
	reports: 'LAYER_REPORTS',
};

/** Fixed per layer so a filter or range change never repaints what a color means. */
export const LAYER_FILL_CLASS: Partial<Record<string, string>> = {
	valentina: 'bg-purple-500',
	grounding_check: 'bg-green-500',
	rag: 'bg-amber-500',
	reports: 'bg-purple-300',
};
export const LAYER_FILL_FALLBACK = 'bg-grey-400';
